/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_HiInputs */

const en_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const es_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const de_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const zh_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const ar_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const fr_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const vi_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const sw_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const th_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const bs_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const ja_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const ko_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const pt_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const it_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const sv_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const nl_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const da_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const nb_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const fi_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const pl_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const ru_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const tr_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const hi_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const id_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const ms_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const cs_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const el_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const he_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const af_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

const hu_nav_language_hi = /** @type {(inputs: Nav_Language_HiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिन्दी`)
};

/**
* | output |
* | --- |
* | "हिन्दी" |
*
* @param {Nav_Language_HiInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_hi = /** @type {((inputs?: Nav_Language_HiInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_HiInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_hi(inputs)
	if (locale === "de") return de_nav_language_hi(inputs)
	if (locale === "zh") return zh_nav_language_hi(inputs)
	if (locale === "ar") return ar_nav_language_hi(inputs)
	if (locale === "fr") return fr_nav_language_hi(inputs)
	if (locale === "vi") return vi_nav_language_hi(inputs)
	if (locale === "sw") return sw_nav_language_hi(inputs)
	if (locale === "th") return th_nav_language_hi(inputs)
	if (locale === "bs") return bs_nav_language_hi(inputs)
	if (locale === "ja") return ja_nav_language_hi(inputs)
	if (locale === "ko") return ko_nav_language_hi(inputs)
	if (locale === "pt") return pt_nav_language_hi(inputs)
	if (locale === "it") return it_nav_language_hi(inputs)
	if (locale === "sv") return sv_nav_language_hi(inputs)
	if (locale === "nl") return nl_nav_language_hi(inputs)
	if (locale === "da") return da_nav_language_hi(inputs)
	if (locale === "nb") return nb_nav_language_hi(inputs)
	if (locale === "fi") return fi_nav_language_hi(inputs)
	if (locale === "pl") return pl_nav_language_hi(inputs)
	if (locale === "ru") return ru_nav_language_hi(inputs)
	if (locale === "tr") return tr_nav_language_hi(inputs)
	if (locale === "hi") return hi_nav_language_hi(inputs)
	if (locale === "id") return id_nav_language_hi(inputs)
	if (locale === "ms") return ms_nav_language_hi(inputs)
	if (locale === "cs") return cs_nav_language_hi(inputs)
	if (locale === "el") return el_nav_language_hi(inputs)
	if (locale === "he") return he_nav_language_hi(inputs)
	if (locale === "af") return af_nav_language_hi(inputs)
	if (locale === "hu") return hu_nav_language_hi(inputs)
	return en_nav_language_hi(inputs)
});